import { useEffect, useState } from 'react'
import { useRouteError, isRouteErrorResponse, Link } from 'react-router'
import { ErrorState } from '@/shared/ui'
import { isChunkLoadError, recoverFromChunkLoadError } from '@/shared/utils/chunkReload'

export default function RouteError() {
  const error = useRouteError()
  const chunkLoadError = !isRouteErrorResponse(error) && isChunkLoadError(error)
  const [showChunkError, setShowChunkError] = useState(false)

  useEffect(() => {
    if (chunkLoadError) {
      setShowChunkError(!recoverFromChunkLoadError(error))
      return
    }
    if (!isRouteErrorResponse(error)) recoverFromChunkLoadError(error)
  }, [chunkLoadError, error])

  if (chunkLoadError && !showChunkError) {
    return <div className="min-h-screen bg-bg" aria-busy="true" />
  }

  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : chunkLoadError
      ? '새 버전을 불러오고 있습니다'
      : '오류가 발생했습니다'

  const message = isRouteErrorResponse(error)
    ? error.data
    : chunkLoadError
      ? '화면이 업데이트되어 다시 불러오는 중입니다. 잠시 후에도 같은 화면이 보이면 새로고침해 주세요.'
    : error instanceof Error
      ? error.message
      : '알 수 없는 오류입니다.'

  return (
    <div className="min-h-screen bg-bg">
      <ErrorState
        title={title}
        message={String(message)}
        action={
          <Link
            to="/"
            reloadDocument={chunkLoadError}
            className="inline-flex h-11 items-center justify-center rounded-md bg-brand px-4 text-preset-body-strong text-white shadow-card transition hover:bg-brand-pressed"
          >
            {chunkLoadError ? '새로고침' : '홈으로 돌아가기'}
          </Link>
        }
      />
    </div>
  )
}
